import { call, put } from "redux-saga/effects";
import NotificationsActions from "../redux/notifications";

const saveNotificationsAction = function* saveNotifications({ notifications }) {
  console.log("saveNotificationsAction - SAGA - notifications", notifications);
  yield put(NotificationsActions.saveNotificationsSuccess(notifications));
};

export const saveNotifications = saveNotificationsAction;
